<section class="datatable datatable--flat tasks-datatable-card">
    <form [formGroup]="dtForm" *ngIf="iShowHeader">
        <header class="datatable__header tasks-datatable__header">
            <div class="datatable-toolbar tasks-datatable__toolbar">
                <div class="datatable-toolbar-start tasks-toolbar-group">
                    <div *ngIf="iShowSearch" class="datatable__search">
                        <div class="datatable__search-field">
                            <i-feather name="search"></i-feather>
                            <input id="txtSearchQuery" type="text" formControlName="searchQuery" [placeholder]="('SEARCH' | translate) + ' ' + (isCompleted ? ('COMPLETED' | translate) : ('TO_DO' | translate))" class="datatable__search-input"
                                aria-controls="tickets-table"
                                (keydown.enter)="doServerSearch($event)">
                        </div>
                    </div>
                    <div *ngIf="iShowUserFilter" class="datatable__search tasks-datatable__user-filter">
                        <div class="datatable__filter-field">
                            <ng-select
                                class="datatable__select tasks-datatable__user-select"
                                [items]="allUsers"
                                bindLabel="fullName"
                                bindValue="id"
                                [(ngModel)]="selectedUserId"
                                [ngModelOptions]="{ standalone: true }"
                                [placeholder]="'FILTER_BY_USER' | translate"
                                [clearable]="true"
                                (ngModelChange)="onUserFilterChange()"
                                (clear)="onUserFilterCleared()">
                            </ng-select>
                        </div>
                    </div>
                    <button *ngIf="activePage===PAGE_NAMES.Tasks" type="button" class="blue-button tasks-add-button" (click)="onAddTaskClick('add')">{{ 'ADD_TASK' | translate }}</button>
                    <div *ngIf="!iHideHeaderActions || iShowExport" class="datatable-toolbar-actions tasks-toolbar-actions">
                        <div *ngIf="!iHideHeaderActions && (isAdmin || iCanWrite)" ngbDropdown
                            class="d-inline-block dropdown-custom">
                            <button class="tasks-actions-button" id="dropdownBasic1"
                                ngbDropdownToggle>{{ 'ACTIONS' | translate }} ({{ checkedItemsCount }} {{ 'SELECTED' | translate }})</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button *ngIf="isAdmin && iShowDropDownDelete" class="noborder-button"
                                    (click)="deleteRows()" ngbDropdownItem>{{ 'DELETE' | translate }}</button>
                                <button *ngIf="(isAdmin || iCanWrite) && iShowDropDownEdit" class="noborder-button"
                                    (click)="editRows()" ngbDropdownItem>{{ 'EDIT' | translate }}</button>

                                <button *ngIf="iShowMerge && checkedItemsCount >= 2" type="button"
                                    ngbDropdownItem (click)="mergeRecords()"
                                    [title]="'SELECT_TWO_OR_MORE_TO_MERGE' | translate">{{ 'MERGE_SELECTED' | translate }}
                                </button>
                            </div>
                        </div>
                        <div class="d-inline-block">
                            <button *ngIf="iShowExport" type="button" class="datatable-button datatable-button--secondary tasks-compact-button"
                                (click)="exportToCsv()">{{ 'EXPORT' | translate }}</button>
                        </div>
                    </div>
                </div>
                <div *ngIf="iShowDateRange" class="datatable__date-range tasks-date-range">
                    <label class="datatable__date-label">{{ 'FROM' | translate }}: </label>
                    <input id="dtStartDate"
                        mwlFlatpickr [altInputClass]="'datetime'" [altInput]="true"
                        [convertModelValue]="true" formControlName="startDate" class="datatable__input" />
                    <label class="datatable__date-label">{{ 'TO' | translate }}: </label>
                    <input id="dtEndDate"
                        mwlFlatpickr [altInputClass]="'datetime'" [altInput]="true"
                        [convertModelValue]="true" formControlName="endDate" class="datatable__input" /><a (click)="clearDates()"><i-feather name="x-circle" class="datatable-clear-icon"></i-feather></a>
                </div>
                <div class="datatable-toolbar-end true-flex hide-from-small tasks-toolbar-end tasks-toolbar-pagination">
                    <div class="datatable__pagination-group">
                    <ng-select class="datatable__select tasks-page-size-select tasks-page-size-select-wide"
                        [clearable]="false"
                        [searchable]="false"
                        [ngModel]="pageSize"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onPageSizeChange($event)">
                        <ng-option [value]="10">{{ 'COUNT_PER_PAGE' | translate:{count:10} }}</ng-option>
                        <ng-option [value]="25">{{ 'COUNT_PER_PAGE' | translate:{count:25} }}</ng-option>
                        <ng-option [value]="50">{{ 'COUNT_PER_PAGE' | translate:{count:50} }}</ng-option>
                        <ng-option [value]="100">{{ 'COUNT_PER_PAGE' | translate:{count:100} }}</ng-option>
                        <ng-option [value]="250">{{ 'COUNT_PER_PAGE' | translate:{count:250} }}</ng-option>
                        <ng-option [value]="500">{{ 'COUNT_PER_PAGE' | translate:{count:500} }}</ng-option>
                    </ng-select>
                    <div class="datatable__pagination pagination-rounded">
                        <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                            [collectionSize]="collectionSize" [page]="pageNumber"  [boundaryLinks]="true"
                            (pageChange)="onPageChange($event)" [pageSize]="f.pageSize.value">
                        </ngb-pagination>
                    </div>
                    </div>
                </div>
            </div>
        </header>
    </form>
    <div class="datatable__body tasks-datatable__body">
        <table cellspacing="0" cellpadding="0" id="datatable" class="datatable__table tasks-datatable__table">
            <thead>
                <tr>
                    <th *ngIf="iShowSelect  && (isAdmin || iCanDelete || iCanWrite)">
                        <div class="datatable__checkbox">
                            <input [checked]="selectAllChecked" (change)="onCbHeadChange($event)" class="datatable__checkbox-input" type="checkbox">
                        </div>
                    </th>
                    <ng-container *ngFor="let col of iColumns; let i=index">
                        <th *ngIf="col.visible === undefined || col.visible" dtSortable
                            [attr.sortable]="(col.sortable  && col.sortable)? col.field : null"
                            [sortable]="(col.sortable  && col.sortable)? col.field : null"
                            (sort)="onSort($event, col)">
                            {{ col.title | translate }}
                            <ng-container *ngIf="col.title === '' && col.field === 'media'">
                                <i class="far fa-image fa-2x"></i>
                            </ng-container>
                            <ng-container *ngIf="col.title === '' && col.field === 'html'">
                                <i class="fas fa-code fa-2x"></i>
                            </ng-container>
                        </th>
                    </ng-container>
                    <th *ngIf="(iShowActions || iShowViewAction) && (iCanWrite || iCanDelete)">
                        {{ 'ACTIONS' | translate }}
                    </th>
                    <th *ngIf="!((iShowActions || iShowViewAction) && (iCanWrite || iCanDelete))"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="viewData.length==0">
                    <td class="datatable-empty-state"
                        [attr.colspan]="(iColumns.length + 2)">
                        {{ 'NO_DATA_FOUND' | translate }}
                    </td>
                </tr>
                <tr [style.color]="row.isDeleted ? 'red' : null" *ngFor="let row of viewData; let i=index">
                    <td *ngIf="iShowSelect && (isAdmin || iCanDelete || iCanWrite)" class="show-check">
                        <div class="datatable__checkbox">
                            <input [checked]="!!row.isSelected" (change)="onCbChange($event,row)"
                                (click)="$event.stopPropagation();" class="datatable__checkbox-input" type="checkbox">
                        </div>
                    </td>
                    <td *ngFor="let col of iColumns; let j=index" class="datatable-cell" [class.datatable-cell--due]="col.field === 'dueDate'">
                        <p class="task-label datatable-label-inline">{{ (col.title | translate) }}: </p>
                        <a *ngIf="(col.visible === undefined || col.visible )"
                            class="datatable-link"
                            [class.datatable-link--due]="col.field === 'dueDate'"
                            [class.datatable-link--due-warning]="col.field === 'dueDate' && iShowRedStyling && checkDueDate(row)"
                            [class.datatable-link--due-danger]="col.field === 'dueDate' && iShowRedStyling && !checkDueDate(row)"
                            (click)="oRowClick.emit(row)" [routerLink]="getRowLink(row).routerLink"
                            [queryParams]="getRowLink(row).queryParams" role="link">
                            <div *ngIf="col.anchorLink && col.anchorLink; else html">
                                <a class="datatable-anchor-link" [routerLink]="getAnchorLink(col.anchorType, row[col.anchorParamsField] )">
                                    {{row[col.field]}}
                                </a>
                            </div>
                            <ng-template #html>
                                <div *ngIf="col.type === 'html'; else image"
                                    [innerHTML]="SafeHtml(row[col.field])">
                                </div>
                            </ng-template>
                            <ng-template #image>
                                <div *ngIf="col.type === 'image'; else normal">
                                    <img [src]="SafeUrl(extractFieldValue(row, col.field,col.pipe, col?.pipeArgs))"
                                        class="datatable-thumb" />
                                </div>
                            </ng-template>
                            <ng-template #normal>
                                <ng-container *ngIf="col.translate; else noTranslateCell">
                                    <ngb-highlight
                                        [result]="extractFieldValue(row, col.field, col.pipe, col?.pipeArgs) | translate">
                                    </ngb-highlight>
                                </ng-container>
                                <ng-template #noTranslateCell>
                                    <ngb-highlight
                                        [result]="extractFieldValue(row, col.field, col.pipe, col?.pipeArgs)">
                                    </ngb-highlight>
                                </ng-template>
                            </ng-template>
                        </a>
                    </td>
                    <td
                        *ngIf="( iShowActions || iShowViewAction )  && (iCanWrite || iCanDelete || iCanRead || true)">
                        <div class="actions-container">
                            <a *ngIf="iShowEditAction && (isAdmin || (iCanWrite && (row.canBeEdit == null || row.canBeEdit == true)) )" class="a-btn datatable-action-link"
                            (click)="editRow(row);$event.stopPropagation();">
                                <i-feather name="edit"></i-feather>
                            </a>
                            <a *ngIf="iShowViewAction && (isAdmin || iCanRead)" class="a-btn datatable-action-link"
                                (click)="viewRow(row);$event.stopPropagation();"
                                [attr.title]="'VIEW' | translate">
                                <i-feather name="eye"></i-feather>
                            </a>
                            <a *ngIf="iShowExternalAction && (isAdmin || iCanRead)" class="a-btn datatable-action-link"
                                (click)="showExternal(row);$event.stopPropagation();"
                                [attr.title]="'OPENS_ON_NEW_PAGE' | translate">
                                <i-feather name="external-link"></i-feather>
                            </a>
                            <a *ngIf="showDeleteAction(row) && iShowDeleteAction && (isAdmin || iCanDelete) && ( activePage === PAGE_NAMES.Users ? iActiveUserId !== row?.id && row?.archived == true : true)"
                                class="a-btn datatable-action-link"
                                (click)="onDeleteRow($event,row);$event.stopPropagation();">
                                <i-feather name="trash"></i-feather>
                            </a>
                            <a *ngIf="(isAdmin || iCanDelete) && ( activePage === PAGE_NAMES.Users ? iActiveUserId !== row?.id  && row?.archived == true : false)"
                                class="a-btn datatable-action-link"
                                (click)="onUnArchiveRow($event,row);$event.stopPropagation();">
                                <mat-icon [attr.title]="'UNARCHIVE' | translate">unarchive</mat-icon>
                            </a>
                            <a *ngIf="(isAdmin || iCanDelete) && ( activePage === PAGE_NAMES.Users ? iActiveUserId !== row?.id  && row?.archived == false : false)"
                                class="a-btn datatable-action-link"
                                (click)="onArchiveRow($event,row);$event.stopPropagation();">
                                <mat-icon [attr.title]="'ARCHIVE' | translate">archive</mat-icon>
                            </a>
                            <a *ngIf="iShowSendEmail" [attr.title]="'EMAIL' | translate" class="a-btn datatable-action-link"
                                (click)="onSendEmail(row);$event.stopPropagation();">
                                <i-feather name="mail"></i-feather>
                            </a>
                            <a *ngIf="iShowMakeCopyAction && iCanWrite" [attr.title]="'CREATE_COPY_OF_THIS_PRODUCT' | translate" class="a-btn datatable-action-link"
                                (click)="oOnCopyClicked.emit(row);$event.stopPropagation();">
                                <i-feather name="copy"></i-feather>
                            </a>
                            <button *ngIf="showCustomAction(row)" type="button" class="datatable-button datatable-button--secondary datatable-compact-button"
                                (click)="executeCustomAction(row)">{{iCustomActionLabel}}</button>
                        </div>
                    </td>
                    <td *ngIf="!(( iShowActions || iShowViewAction )  && (iCanWrite || iCanDelete || iCanRead || true))" class="hide-from-small"></td>
                </tr>
            </tbody>
        </table>
    </div>
    <form [formGroup]="dtForm" *ngIf="iShowHeader">
        <footer class="datatable__footer tasks-toolbar-end tasks-datatable__footer">
            <div class="datatable__pagination-group">
            <ng-select class="datatable__select tasks-page-size-select tasks-page-size-select-compact"
                [clearable]="false"
                [searchable]="false"
                [ngModel]="pageSize"
                [ngModelOptions]="{standalone: true}"
                (change)="onPageSizeChange($event)">
                <ng-option [value]="10">{{ 'COUNT_PER_PAGE' | translate:{count:10} }}</ng-option>
                <ng-option [value]="25">{{ 'COUNT_PER_PAGE' | translate:{count:25} }}</ng-option>
                <ng-option [value]="50">{{ 'COUNT_PER_PAGE' | translate:{count:50} }}</ng-option>
                <ng-option [value]="100">{{ 'COUNT_PER_PAGE' | translate:{count:100} }}</ng-option>
                <ng-option [value]="250">{{ 'COUNT_PER_PAGE' | translate:{count:250} }}</ng-option>
                <ng-option [value]="500">{{ 'COUNT_PER_PAGE' | translate:{count:500} }}</ng-option>
            </ng-select>
            <div class="datatable__pagination pagination-rounded">
                <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                    [collectionSize]="collectionSize" [page]="pageNumber" [boundaryLinks]="true"
                    (pageChange)="onPageChange($event)" [pageSize]="f.pageSize.value">
                </ngb-pagination>
            </div>
            </div>
        </footer>
    </form>
</section>
